/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TransactionDashboardCount } from '../../models/transaction-dashboard-count';

export interface GetTransactionDashboard$Params {

/**
 * The start date time of data to filter
 */
  startDate: string;

/**
 * The end date time of data to filter
 */
  endDate: string;
}

export function getTransactionDashboard(http: HttpClient, rootUrl: string, params: GetTransactionDashboard$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionDashboardCount>> {
  const rb = new RequestBuilder(rootUrl, getTransactionDashboard.PATH, 'post');
  if (params) {
    rb.query('startDate', params.startDate, {});
    rb.query('endDate', params.endDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TransactionDashboardCount>;
    })
  );
}

getTransactionDashboard.PATH = '/custom/transactions/dashboard';
